import Axios from "axios";
import {
    SET_PRD_DELIVERY_LIST,
    UNSET_PRD_DELIVERY_LIST,
} from "@/store/mutation-types";
import { 
    prdDeliveryResource,
} from "@/store/api";

const state = {
    getPrdDeliveryList: [],
};

const getters = {
    getPrdDeliveryList(state) {
        return state.getPrdDeliveryList;
    },
};

const mutations = {
    [SET_PRD_DELIVERY_LIST](state, data) {
        state.getPrdDeliveryList = data;
    },
    [UNSET_PRD_DELIVERY_LIST](state) {
        state.getPrdDeliveryList = [];
    },
};

const actions = {
    savePrdDelivery({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(prdDeliveryResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updatePrdDelivery({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${prdDeliveryResource}/${data.id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getPrdDeliveryList({ commit }, data) {
        return new Promise((resolve, reject) => {
        Axios.get(prdDeliveryResource, { params: data })
            .then(function (response) {
            commit('SET_PRD_DELIVERY_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_PRD_DELIVERY_LIST');
            reject(error);
            });
        });
    },

    getPrdDeliveryById({ commit }, data) {
        const fullUrl = `${prdDeliveryResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(fullUrl)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

